module.exports = "/assets/images/8c0c6eff12aba87154577702db24b006.png";